import angular from 'angular';

var ibanReplaceLetters = function(ibanString) {
  ibanString = ibanString.replace(/A/g, '10');
  ibanString = ibanString.replace(/B/g, '11');
  ibanString = ibanString.replace(/C/g, '12');
  ibanString = ibanString.replace(/D/g, '13');
  ibanString = ibanString.replace(/E/g, '14');
  ibanString = ibanString.replace(/F/g, '15');
  ibanString = ibanString.replace(/G/g, '16');
  ibanString = ibanString.replace(/H/g, '17');
  ibanString = ibanString.replace(/I/g, '18');
  ibanString = ibanString.replace(/J/g, '19');
  ibanString = ibanString.replace(/K/g, '20');
  ibanString = ibanString.replace(/L/g, '21');
  ibanString = ibanString.replace(/M/g, '22');
  ibanString = ibanString.replace(/N/g, '23');
  ibanString = ibanString.replace(/O/g, '24');
  ibanString = ibanString.replace(/P/g, '25');
  ibanString = ibanString.replace(/Q/g, '26');
  ibanString = ibanString.replace(/R/g, '27');
  ibanString = ibanString.replace(/S/g, '28');
  ibanString = ibanString.replace(/T/g, '29');
  ibanString = ibanString.replace(/U/g, '30');
  ibanString = ibanString.replace(/V/g, '31');
  ibanString = ibanString.replace(/W/g, '32');
  ibanString = ibanString.replace(/X/g, '33');
  ibanString = ibanString.replace(/Y/g, '34');
  ibanString = ibanString.replace(/Z/g, '35');
  return ibanString;
};

angular.module('cloudX').directive('validateIban', function() {
  return {
    restrict: 'A',
    require: ['?ngModel', '^?bindErrors'],
    link: function(scope, element, attrs, ctrls) {
      var ngModel = ctrls[0];
      var bindErrors = ctrls[1];
      if (!ngModel) return; // do nothing if no ng-model
      ngModel.$validators.iban = function(modelValue, viewValue) {
        var value = modelValue || viewValue || null;
        if (value === null) return true; //Allow null and empty values
        //Replace invalid characters and spaces
        value = value.replace(/[^0-9a-zA-Z]/g, '');
        if (value.length <= 4) return false;

        //Als iban Belgisch is, controleer de lengte
        if (value.substr(0, 2).toUpperCase() === 'BE' && value.length !== 16) return false;

        // verplaats de eerste 4 chars naar achteraan
        var toTest = value.substr(4) + value.substr(0, 4);
        // vervang elke letter door twee cijfers (A=10, ... Z=35)
        toTest = ibanReplaceLetters(toTest.toUpperCase());
        // getal modulo 97 == 1 => correcte iban
        // we moeten dit in stukken doen omdat het getal te groot is om mee te rekenen in javascript
        var numTest;
        var mod = '';

        while (toTest.length > 9) {
          numTest = mod + toTest.substring(0, 9);
          toTest = toTest.substring(9);
          mod = parseInt(numTest) % 97;
        }
        numTest = mod + toTest;
        mod = parseInt(numTest) % 97;

        return mod === 1;
      };
      if (bindErrors) {
        bindErrors.addError('iban', 6018);
      }
    },
  };
});
